<template>
    <div class="activeApply active edit">
      <van-cell-group class="">
        <van-cell title="活动名称">
          <van-field placeholder="请输入活动名称" class="item2" v-model="campaign.Name"  @input="limitLength(100,'campaign','Name')"/>
        </van-cell>
        <van-cell title="活动日期" >
         <div class="flex">
           <div class="flex item1" @click="showDateTime1=!showDateTime1">
             <p class="item1 date-time black" v-if="campaign.U_RangeTime">{{firstDate}}</p>
             <p class="item1 date-time" v-else>{{firstDate || "请选择"}}</p>
             <div slot="right-icon"  class="triangle_border_down" />
           </div>
           <van-popup v-model="showDateTime1" position="bottom">
             <van-datetime-picker
               type="date"
               :min-date="new Date()"
               @confirm="getFirstDate"
               @cancel="showDateTime1=!showDateTime1"
             />
           </van-popup>
           <div class="flex item1" @click="showDateTime2=!showDateTime2">
             <p class="item1 date-time black" v-if="campaign.U_RangeTime">{{endDate}}</p>
             <p class="item1 date-time" v-else>{{endDate || "请选择"}}</p>
             <div slot="right-icon"  class="triangle_border_down" />
           </div>
           <van-popup v-model="showDateTime2" position="bottom">
             <van-datetime-picker
               type="date"
               :min-date="new Date()"
               @confirm="getLastDate"
               @cancel="showDateTime2=!showDateTime2"
             />
           </van-popup>
         </div>

        </van-cell>
        <van-cell title="活动地点">
          <van-field placeholder="请输入活动地点" class="item2" v-model="campaign.U_CampPlace" @input="limitLength(254,'campaign','U_CampPlace')"/>
        </van-cell>
        <van-cell title="邀请人数">
          <van-field type="number" placeholder="请输入邀请人数" class="item2" v-model="campaign.U_InvitedCnt" @input="limitLength(64,'campaign','U_InvitedCnt')"/>
        </van-cell>
        <van-cell title="集客目标">
          <van-field type="number" placeholder="请输入集客目标" class="item2" v-model="campaign.U_FansTarget" @input="limitLength(100,'campaign','U_FansTarget')"/>
        </van-cell>
        <van-cell title="销售目标">
          <van-field type="number" placeholder="请输入销售目标" class="item2" v-model="campaign.U_SaleTarget" @input="limitLength(100,'campaign','U_SaleTarget')"/>
        </van-cell>
        <van-cell title="讲师姓名">
          <van-field placeholder="请输入讲师姓名" class="item2" v-model="campaign.U_TeacherName" @input="limitLength(100,'campaign','U_TeacherName')"/>
        </van-cell>
        <van-cell title="合作伙伴">
          <van-field placeholder="请输入合作伙伴" class="item2" v-model="campaign.U_Partner" @input="limitLength(100,'campaign','U_Partner')"/>
        </van-cell>
        <van-cell title="活动类型" @click="showTypes=!showTypes">
          <div class="flex item1">
            <p class="item1 date-time black" v-if="typeName">{{typeName}}</p>
            <p class="item1 date-time" v-else>请选择</p>
            <div slot="right-icon"  class="triangle_border_down" />
          </div>
          <!--<van-field placeholder="请选择活动类型" class="item2" v-model="typeName"/>-->
          <!--<div slot="right-icon"  class="triangle_border_down" />-->
        </van-cell>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="活动主题"  />        </van-cell>
        <quillEditImg quillId="U_Theme" :content="campaign.U_Theme" @change="onEditorChange($event,'U_Theme')"></quillEditImg>

        <!--<quill-editor -->
                        <!--&gt;-->
          <!--</quill-editor>-->
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="活动目的"  />  </van-cell>
        <quillEditImg quillId="U_Purpose" :content="campaign.U_Purpose" @change="onEditorChange($event,'U_Purpose')"></quillEditImg>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="讲师介绍"  />        </van-cell>
        <quillEditImg quillId="U_Instructor" :content="campaign.U_Instructor" @change="onEditorChange($event,'U_Instructor')"></quillEditImg>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="场地介绍"  />        </van-cell>
        <quillEditImg quillId="U_Venue" :content="campaign.U_Venue" @change="onEditorChange($event,'U_Venue')"></quillEditImg>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell title="活动流程"  />
        </van-cell>

        <div class="table van-hairline--surround">
             <div class="table-title flex ">
                 <p class="item1">序号</p>
                 <p class="item2">日期</p>
                 <p class="item2">时间</p>
                 <p class="item3">内容</p>
             </div>
              <!--<ul class="table-content flex van-hairline&#45;&#45;top">-->
                <!--<li class="item1 van-hairline&#45;&#45;right">1</li>-->
                <!--<li class="item2 van-hairline&#45;&#45;right">2018.02.02</li>-->
                <!--<li class="item2 van-hairline&#45;&#45;right">09.00-09.30</li>-->
                <!--<li class="item3 flex">-->
                  <!--<p class="item1 content van-hairline&#45;&#45;right">所有人员集合 并到前台签到</p>-->
                  <!--<van-icon name="cross" class="close"/>-->
                <!--</li>-->
              <!--</ul>-->
            <template v-for="(item,index) in processList">
              <ul class="table-content flex van-hairline--top" @click="liuchengEdit(item,index)">
                <li class="item1 van-hairline--right">{{item.U_Sort}}</li>
                <li class="item2 van-hairline--right">{{item.U_Flow|getActiveDate}}</li>
                <li class="item2 van-hairline--right">{{item.U_Flow|getActiveTime}}</li>
                <li class="item3 flex">
                  <!--<p class="item1 content van-hairline&#45;&#45;right">{{item.U_Details}}</p>-->
                  <p class="item1  van-hairline--right" >
                    <span style="line-height: 20px;display: inline-block">{{item.U_Details}}</span>
                  </p>
                  <van-icon name="cross" class="close" @click.stop="processList.splice(index,1)"/>
                </li>
              </ul>
            </template>

              <div class="table-content add-table van-hairline--top" @click="liuchengEdit()">
                  +添加一栏
              </div>
          </div>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell   >
          <template slot="title">
            <span class="custom-text">活动预算</span>
            <!--<span class="mini-text">（未税{{totalBudget.amount||0}}，含税{{totalBudget.unamount||0}}）</span>-->
          </template>
        </van-cell>
        <div class="table van-hairline--surround">
            <div class="table-title flex ">
              <p class="item1">序号</p>
              <p class="item2">名称</p>
              <p class="item1">数量</p>
              <p class="item3">未税费用</p>
              <p class="item3">含税费用</p>
            </div>
          <template v-for="(item,index) in budgetList">
            <ul class="table-content flex van-hairline--top" @click="yusuanEdit(item,index)">
              <li class="item1 van-hairline--right">{{index+1}}</li>
              <li class="item2 van-hairline--right">{{item.Name}}</li>
              <li class="item1 van-hairline--right">{{item.U_Qty}}</li>
              <li class="item3 van-hairline--right">{{item.U_Amount}}</li>
              <li class="item3 flex">
                <p class="item1 van-hairline--right ">{{item.U_AmountAftTax}}</p>
                <van-icon name="cross" class="close" @click.stop="budgetList.splice(index,1)"/>
              </li>
            </ul>
          </template>
          <!--<ul class="table-content flex van-hairline&#45;&#45;top">-->
            <!--<li class="item1 van-hairline&#45;&#45;right">1</li>-->
            <!--<li class="item2 van-hairline&#45;&#45;right">场地费</li>-->
            <!--<li class="item1 van-hairline&#45;&#45;right">1</li>-->
            <!--<p class="item3 van-hairline&#45;&#45;right">2000</p>-->
            <!--<li class="item3 flex">-->
              <!--<p class="item1">3000</p>-->
              <!--<van-icon name="cross" class="close"/>-->
            <!--</li>-->
          <!--</ul>-->
            <div class="table-content add-table van-hairline--top" @click="yusuanEdit()">
              +添加一栏
            </div>
          </div>
      </van-cell-group>

      <van-cell-group class="group group-table">
        <van-cell   >
          <template slot="title">
            <span class="custom-text">物料申请</span>
          </template>
        </van-cell>
        <div class="table van-hairline--surround">
          <div class="table-title flex ">
            <p class="item1">序号</p>
            <p class="item3">产品一级分类</p>
            <p class="item2">产品名称</p>
            <p class="item1">数量</p>
            <p class="item3">归还日期</p>
          </div>
          <template v-for="(item,index) in materialList">
            <ul class="table-content flex van-hairline--top" @click="wuliaoEdit(item,index)">
              <li class="item1 van-hairline--right">{{index+1}}</li>
              <li class="item3 van-hairline--right">{{item.U_MaterialClass}}</li>
              <li class="item2 van-hairline--right">{{item.Name}}</li>
              <li class="item1 van-hairline--right">{{item.U_Qty}}</li>
              <li class="item3 flex">
                <p class="item1 van-hairline--right" >
                  {{item.U_ReturnDate|getDate}}
                </p>
                <van-icon name="cross" class="close" @click.stop="materialList.splice(index,1)"/>
              </li>
            </ul>
          </template>
          <!--<ul class="table-content flex van-hairline&#45;&#45;top">-->
            <!--<li class="item1">1</li>-->
            <!--<li class="item2">甲类</li>-->
            <!--<li class="item1">某某某</li>-->
            <!--<p class="item1">20</p>-->
            <!--<li class="item3 flex">-->
              <!--<p class="item1">2019-02-28</p>-->
              <!--<van-icon name="cross" class="close"/>-->
            <!--</li>-->
          <!--</ul>-->
          <div class="table-content add-table van-hairline--top" @click="wuliaoEdit()">
            +添加一栏
          </div>
        </div>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell title="图片"  />  </van-cell>

        <div class="clear">
          <template v-for="(item,index) in imgList">
            <p class="upload-img fl">
              <img :src="$config.serverURL+'/upload/'+item.U_url" alt="">
              <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px" @click="delImg(index)"/>
            </p>
          </template>
          <van-uploader :after-read="afterRead" class="upload fl" multiple>
            <van-icon name="plus" />
            <p>上传图片</p>
          </van-uploader>
        </div>
      </van-cell-group>

      <van-cell-group class="group">
        <van-cell   >
          <template slot="title">
            <span class="custom-text">备注</span>
            <!--<span class="mini-text c-red">（提交时备注必填）</span>-->
          </template>
        </van-cell>
        <van-field
          class="textarea"
          type="textarea"
          placeholder="请输入备注内容描述"
          rows="3"
          autosize
          v-model="campaign.U_Remark"
          @input="limitLength(254,'campaign','U_Remark')"
        />
      </van-cell-group>

      <div class="bottom-btn flex">
          <div class="item1 btn save" @click="sub(campStatus.D)">保存</div>
          <div class="item1 btn sub" @click="sub(campStatus.W)">提交</div>
      </div>

      <!--<dateTime v-model="showDateTime" :firstDate="firstDate" :endDate="endDate" @endChange="dateChange"></dateTime>-->
      <typePop v-model="showTypes"  @typeChange="typeChange" :typeId="campaign.U_CampType"></typePop>
      <liuchengPop v-model="showliucheng" :maxDate="endDate" :minDate="firstDate" @newLiucheng="newLiucheng" :obj="liuchengValue"></liuchengPop>
      <yusuanPop  v-model="showYusuan" @newYusuan="newYusuan" :info="yusuanValue"></yusuanPop>
      <wuliaoPop v-model="showWuliao" @newWuliao="newWuliao" :info="wuliaoValue"></wuliaoPop>
      <backTo url="/active/list"></backTo>
    </div>
</template>
<script>
  import moment from 'moment'
  import $config  from '@/config/config';
  import dateTime from './component/datetime.vue'
  import typePop from './component/typePop.vue'
  import liuchengPop from './component/liuchengPop.vue'
  import yusuanPop from './component/yusuanPop.vue'
  import wuliaoPop from './component/wuliaoPop.vue'
  import backTo from './component/backTo.vue'
  import quillEditImg from './component/quillEditImg.vue'
  import campKit from '@/common/campKit';
  import imageCompression from 'browser-image-compression';

    export default{
        data(){
            return {
              id:'',
              campFlowType:1,
              campaign:{
                campType:1
              },  //基本信息
              processList:[],  //活动流程列表
              budgetList:[],  //活动预算列表
              materialList:[], //物料申请列表
              imgList:[], //物料申请图片列表
              flowRecordList:[], //审批记录

              totalBudget:{}, //总计

              currentDate: new Date(),
              firstDate:null, //活动初始时间
              endDate:null, //活动结束时间
              firstDateTs : null, //开始时间戳
              endDateTs : null, //结束时间戳

              showDateTime1:false,
              showDateTime2:false,
              showTypes:false,
              typeName:'', //活动类型中文显示

              showliucheng:false,//活动流程弹窗
              liuchengValue:{}, //流程数据
              showYusuan:false,//活动预算弹窗
              yusuanValue:{}, //预算编辑数据
              showWuliao:false, //物料申请弹窗
              wuliaoValue:{}, //物料编辑数据

              subing:false,
              campStatus:campKit.campStatus,
              subStatus:"D"

            }
        },
        components:{
          dateTime,
          typePop,
          liuchengPop,
          yusuanPop,
          wuliaoPop,
          quillEditImg,
          backTo
        },
        filters: {
          getDate: function (value) {
            if (!value) return ''
            if(parseInt(value)==value){
              value = parseInt(value)
            }
            return moment(value).format('YYYY-MM-DD')
          },
          getActiveDate: function (value) {
            if (!value||!value.split(' ')) return ''
            if(value.split(' ').length<=1) return ''
            return value.split(' ')[0]
          },
          getActiveTime: function (value) {
            if (!value||!value.split(' ')) return ''
            if(value.split(' ').length<=1) return ''
            return value.split(' ')[1]
          }
        },
       watch:{
        'campaign.U_RangeTime':function(){
            if(this.campaign.U_RangeTime){
              this.campaign.U_RangeTime = this.campaign.U_RangeTime.replace(',','-')
            }
        },
         endDate:function(){
            this.wuliaoValue.U_ReturnDate=this.endDate
         }
       },
        methods:{
          getTotalBudget(){//活动预算合计
            let count= 0,amont = 0, unamont = 0
            for( var item of this.budgetList){
              count +=parseInt(item.U_Qty)
              amont +=parseInt(item.U_Amount)
              unamont +=parseInt(item.U_AmountAftTax)
            }
            this.totalBudget={
              count, amont, unamont
            }
            console.log(this.totalBudget)
          },
          getDetail(){
            this.$api.$active.campaignDetail({
              salesId:this.$wxuserUtil.getUserId(),
              id:this.$route.query.id
            }).then(response=>{
              if(response.success==true){
                this.campaign = response.data.campaign
                this.processList = response.data.processList
                this.budgetList = response.data.budgetList
                this.materialList = response.data.materialList
                this.imgList = response.data.materialImgList||[]
                this.flowRecordList = response.data.flowRecordList||[]
                this.typeName = this.campaign.campTypeName
                this.firstDate = this.campaign.U_RangeTime.split(',')[0]
                this.endDate = this.campaign.U_RangeTime.split(',')[1]

                this.firstDateTs = new Date(this.firstDate).getTime();
                this.endDateTs = new Date(this.endDate).getTime();

//            this.memberList = response.data.memberList||[]
                this.qrCode=this.$api.getQrcode(this.campaign.CampaignUrl)

                this.getTotalBudget()
              }else{
                this.$title(`获取活动详情失败,${response.msg}`);
              }
            })
          },
          async afterRead(files){
              console.log(files.constructor)
              if(files.constructor === Array){
                  if(files.length>99){
                    this.$title('图片不能超过99张')
                    return
                  }
                  for(var item of files){
                    await this.onRead(item)
                  }
              }else if(files.constructor === Object){
                  this.onRead(files)
              }
          },
           async onRead(file){
             var fileSrc = file.file;

             var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
             if(!isImg){
               return;
             }

             let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

             this.$toast({
               mask: true,
               message: '上传中...'
             });

            var formData = new FormData()
            formData.append('salesId',this.$wxuserUtil.getUserId())
            formData.append('file',lastFile)

            console.log(lastFile)
            return  this.$api.uploadFile(formData).then(response=>{
              if(response.success==true){
                this.imgList.push({U_url:response.data.fileName})
              }else{
//                this.imgs.splice(this.imgs.length-1,1);
                this.$topTip(this,`图片上传失败,${response.msg}`);
              }
            })
          },
          dateChange(e){
              this.campaign.U_RangeTime = moment(e[0]).format('YYYY-MM-DD')+','+moment(e[1]).format('YYYY-MM-DD')
          },
          typeChange(e){
              this.typeName = e.name
              this.campaign.U_CampType = e.value
          },
          sub(status){
              this.subStatus=status
            if(!this.campaign.Name){
              this.$title('请输入活动名称')
              return
            }
            if(!this.firstDate){
              this.$title('请选择活动开始时间')
              return
            }
            if(!this.endDate){
              this.$title('请选择活动结束时间')
              return
            }
            if(!this.campaign.U_CampPlace){
              this.$title('请输入活动地点')
              return
            }
            if(this.campaign.U_InvitedCnt===''||!/(^[0-9]\d*$)/.test(this.campaign.U_InvitedCnt)){
              this.$title('请输入邀请人数,且邀请人数只能为整数')
              return
            }
            if(this.campaign.U_FansTarget===''||!/(^[0-9]\d*$)/.test(this.campaign.U_FansTarget)){
              this.$title('请输入集客目标,且集客目标只能为整数')
              return
            }
            if(this.campaign.U_SaleTarget===''||!/(^[0-9]\d*$)/.test(this.campaign.U_SaleTarget)){
              this.$title('请输入销售目标,且销售目标只能为整数')
              return
            }
            if(!this.campaign.U_TeacherName){
              this.$title('请输入讲师名字')
              return
            }
            if(!this.campaign.U_Partner){
              this.$title('请输入合作伙伴')
              return
            }
            if(!this.campaign.U_CampType){
              this.$title('请选择活动类型')
              return
            }

            if(!this.campaign.U_Theme){
              this.$title('请输入活动主题')
              return
            }
            if(!this.campaign.U_Purpose){
              this.$title('请输入活动目的')
              return
            }
            if(!this.campaign.U_Instructor){
              this.$title('请输入讲师介绍')
              return
            }
            if(!this.campaign.U_Venue){
              this.$title('请输入场地介绍')
              return
            }

            if(!this.processList||this.processList.length<1){
              this.$title('请输入活动流程')
              return
            }
            if(!this.budgetList||this.budgetList.length<1){
              this.$title('请输入活动预算')
              return
            }
            if(!this.materialList||this.materialList.length<1){
              this.$title('请输入物料申请')
              return
            }

            if(this.subing){
              this.$title('请勿重复提交')
              return
            }else{
              this.subing = true;
            }

            this.$toast({
              duration: 0,
              mask: true,
              message: '活动正在'+(status=="D"?'保存':'提交')+'中，请稍等...'
            });



              let data ={
                salesId:this.$wxuserUtil.getUserId(),
                campFlowType:this.campFlowType,
                campainBase:this.campaign,
                campaignBudgetList:this.budgetList,
                campaignMaterialList:this.materialList,
                campaignProcessList:this.processList,
                imgList:[],
              }
              for(var key in this.processList){
                  data.campaignProcessList[key].flow =this.processList[key].U_Flow
                  data.campaignProcessList[key].sort =this.processList[key].U_Sort
                  data.campaignProcessList[key].details =this.processList[key].U_Details
              }
            for(var key in this.materialList){
              data.campaignMaterialList[key].name =this.materialList[key].Name
              data.campaignMaterialList[key].materialClass =this.materialList[key].U_MaterialClass
              data.campaignMaterialList[key].returnDate =this.materialList[key].U_ReturnDate
              data.campaignMaterialList[key].qyt =this.materialList[key].U_Qty
            }
            for(var key in this.budgetList){
              data.campaignBudgetList[key].name =this.budgetList[key].Name
              data.campaignBudgetList[key].amount =this.budgetList[key].U_Amount
              data.campaignBudgetList[key].amountAftTax =this.budgetList[key].U_AmountAftTax
              data.campaignBudgetList[key].qyt =this.budgetList[key].U_Qty
            }
            for(var key in this.imgList){
              data.imgList.push(this.imgList[key].U_url)
            }
            data.campainBase = { //活动基础对象，必填
                "id" : this.campaign.U_CampaignId||'',//活动ID，编辑时必填
                "name" :this.campaign.Name,//活动名称，必填
                "deptId" : this.$wxuserUtil.getDeptId(),//部门ID，必填
                "rangeTime" : this.firstDate+','+this.endDate,//活动时间，必填
                "invitedCnt" :this.campaign.U_InvitedCnt,//邀请人数，必填
                "teacherName" : this.campaign.U_TeacherName,//讲师姓名，必填
                "partner" :this.campaign.U_Partner,//合作伙伴，必填
                "purpose" : this.campaign.U_Purpose,//活动目的，必填
                "instructor" : this.campaign.U_Instructor,//讲师介绍，必填
                "venue" : this.campaign.U_Venue,//场地介绍，必填
                "saleTarget" : this.campaign.U_SaleTarget,//销售目标，必填
                "campPlace" : this.campaign.U_CampPlace,//活动地址，必填
                "fansTarget" :this.campaign.U_FansTarget	,//集客目标，必填
                "campType" : this.campaign.U_CampType,//活动类型，必填
                "theme" : this.campaign.U_Theme,//活动主题，必填
                "remark" :this.campaign.U_Remark,//提交审批备注
                "approvalStatus" : status//审批状态 D-草稿、W-待审批
            },

              data = JSON.stringify(data)
              this.$api.$active.campaignSubmit(data).then(this.submitCallback,this.submitCallback)
          },

          /**
           * 活动提交的回调函数
           * @param response
           */
          submitCallback(response){
            this.subing = false
            this.$toast.clear();
            let status = this.subStatus
            if(response.success){
              if(status=='D') {
                this.$title('活动保存成功');
              }else{
                this.$title('活动提交成功');
              }
              this.$router.push('/active/activeDetail?id='+response.data)
            }else{
              response = response.responseJSON || response;

              if(status=='D') {
                this.$title(`活动保存失败,${response.msg}`);
              }else{
                this.$title(`活动提交失败,${response.msg}`);
              }
            }
          },

          delImg(index){
            this.imgList.splice(index,1)
          },
          newLiucheng(val){ //新增流程
             let obj = val
            if(!obj.U_Sort){
              obj.U_Sort = this.processList.length+1
              this.processList.push(JSON.parse(JSON.stringify(obj)))
            }else{
                for(var key in this.processList){
                    if(obj.U_Sort==this.processList[key].U_Sort){
                      this.processList.splice(key,1,obj)
                    }
                }
            }
          },
          newYusuan(val){ //新增预算
            let obj = val
            if(!obj.U_Sort){
              obj.U_Sort = this.budgetList.length+1
              this.budgetList.push(JSON.parse(JSON.stringify(obj)))
            }else{
              for(var key in this.budgetList){
                if(obj.U_Sort==this.budgetList[key].U_Sort){
                  this.budgetList.splice(key,1,obj)
                }
              }
            }
            this.getTotalBudget()
          },
          newWuliao(val,index){ //新增预算
            let obj = val
            if(!obj.U_Sort){
              obj.U_Sort = this.materialList.length+1
              this.materialList.push(JSON.parse(JSON.stringify(obj)))
            }else{
              for(var key in this.materialList){
                if(obj.U_Sort==this.materialList[key].U_Sort){
                  this.materialList.splice(key,1,obj)
                }
              }
            }
          },
          onEditorChange(editor,name) {
            this.campaign[name] = editor.html;
          },
          getFirstDate(e){
            var currentDate = e.getTime();
            if(this.endDateTs && currentDate > this.endDateTs){
                this.$title('活动开始时间不可早于结束时间')
                return
            }
            this.showDateTime1=!this.showDateTime1
            this.firstDateTs = currentDate;
            this.firstDate =moment(e).format('YYYY-MM-DD')
          },
          getLastDate(e){
            var currentDate = e.getTime();

            if(this.firstDateTs && this.firstDateTs> currentDate){
              this.$title('活动开始时间不可早于结束时间')
              return
            }
            this.showDateTime2=!this.showDateTime2
            this.endDateTs = currentDate;
            this.endDate =moment(e).format('YYYY-MM-DD')
          },
          liuchengEdit(obj,index){
            if(obj){
              this.liuchengValue=obj
              this.liuchengValue.U_Sort=index+1
            }else{
              this.liuchengValue={}
            }
            this.showliucheng=!this.showliucheng
          },
          yusuanEdit(obj,index){
            if(obj){
              this.yusuanValue=obj
              this.yusuanValue.U_Sort=index+1
            }else{
              this.yusuanValue={}
            }
            this.showYusuan=!this.showYusuan
          },
          wuliaoEdit(obj,index){
            if(obj){
              this.wuliaoValue=obj
              this.wuliaoValue.U_Sort=index+1
            }else{
              this.wuliaoValue={}
            }
            this.wuliaoValue.U_ReturnDate=this.endDate
            this.showWuliao=!this.showWuliao
          },
          limitLength(len,key1,key2){
              let value = ''
            if(key2){
              value =this.$data[key1][key2]
            }else{
              value =this.$data[key1]
            }
            if(value.length>len){
              if(key2){
                this.$data[key1][key2]=value.slice(0,len)
              }else{
                this.$data[key1]=value.slice(0,len)
              }
            }
          }
        },
      created(){
            if(this.$route.query.id){
                this.getDetail()
              window.document.title='修改活动'
            }
            if(this.$route.query.campFlowType){
                this.campFlowType = this.$route.query.campFlowTyp
            }
      },
      mounted() {
        this.$(":focus").blur();
      }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeDetail.less";
  .group{
    margin-top: 10px;
  }
  .mini-text{
    font-size: 11px;
  }
  .date-time{
    text-align: left;
  }
  .black{
    color:#323233
  }
</style>



// WEBPACK FOOTER //
// src/components/active/apply.vue